import React, {FormEventHandler, ChangeEventHandler} from 'react';

export type FormDataType = {[key: string]: string};
export type FormSubmitType = (data: FormDataType) => void;

const useForm = (initialState: FormDataType = {}, onSubmit: FormSubmitType) => {
  const [formData, setFormData] = React.useState(initialState);

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    onSubmit?.(formData);
  };

  return {formData, handleInputChange, handleSubmit};
};

export default useForm;
